import React, { useState } from 'react';
import { Button, Slider, Tooltip } from 'antd';
import { SoundOutlined } from '@ant-design/icons';
import styled from 'styled-components';
const VolumeButton = styled.div`
  display: flex;
  width: 45px;
  height: 45px;
  border-radius: 23px;
  background-color: #05b0d7;
  color: #fff;
  font-size: 28px;
  justify-content: center;
  /* background-repeat: no-repeat; */
  /* background-size: 45px 45px; */
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  position: relative;
  filter: ${(props) => (props.disabled ? 'grayscale(100%)' : 'none')};
  /* margin: 0 5px; */
`;
const VolumeSlider = ({ isMediaOverlay, volume, setVolume, max, min, step, ...props }) => {
  const [show, setShow] = useState(false);

  const handelSetVolume = (value) => {
    setVolume(value);
    // setShow(false);
  };

  return (
    <>
      {show && (
        <div
          style={{
            // marginBottom: '240px',
            marginLeft: '6px',
            height: '200px',
            zIndex: 100,
            padding: '10px',
            bottom: '60px',
            // backgroundColor: '#0ba8ff',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            position: 'absolute',
          }}
        >
          <Slider
            vertical
            min={min}
            max={max}
            value={volume}
            onChange={handelSetVolume}
            style={{ margin: 0 }}
            step={step}
            trackStyle={{ backgroundColor: '#ffa700' }}
            railStyle={{ backgroundColor: '#d4d4d4' }}
            handleStyle={{ borderColor: '#ffa700', backgroundColor: '#ffa700' }}
          />
        </div>
      )}
      <Tooltip title={show || !isMediaOverlay ? '' : 'Volume'} placement="top">
        <VolumeButton
          disabled={!isMediaOverlay}
          onClick={() => {
            if (!isMediaOverlay) return;

            setShow(!show);
          }}
        >
          <SoundOutlined />
        </VolumeButton>
      </Tooltip>
    </>
  );
};

export default VolumeSlider;
